import { render, staticRenderFns } from "./GDrawer.vue?vue&type=template&id=5852a1bd&scoped=true&"
import script from "./GDrawer.vue?vue&type=script&lang=ts&"
export * from "./GDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./GDrawer.vue?vue&type=style&index=0&id=5852a1bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5852a1bd",
  null
  
)

export default component.exports